import api from "./api";
import { handleFileDownload } from "../../utils/fileDownloadHelper";

const analyticsService = {
  getDashboard: async (filters) => {
    try {
      const response = await api.get("/university-admin/analytics/dashboard", {
        params: filters,
      });
      return response.data; // { success, data, errorCode }
    } catch (error) {
      console.error("Error fetching analytics dashboard:", error);
      return { success: false, errorCode: error.response?.data?.errorCode };
    }
  },

  getEvents: async (params) => {
    try {
      const response = await api.get("/university-admin/analytics/events", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching analytics events:", error);
      return { success: false, errorCode: error.response?.data?.errorCode };
    }
  },

  exportAnalytics: async (filters, format) => {
    try {
      const response = await api.get("/university-admin/analytics/export", {
        params: { ...filters, format },
        responseType: "blob",
      });
      
      const success = handleFileDownload(response, `analytics-export-${new Date().toISOString().split('T')[0]}.${format.toLowerCase()}`);
      return { success };
    } catch (error) {
      console.error("Error exporting analytics:", error);
      return { success: false, errorCode: "export.failed" };
    }
  },
};

export default analyticsService;
